// extracted by mini-css-extract-plugin
export default {"component":"TooltipMetricTextForecast_component__G2x4h","dot":"TooltipMetricTextForecast_dot__Ts8q1"};